import { OpportunityProvider } from 'generated/graphql';

// @NOTE-RT: Driven off of `import { OpportunityProvider } from 'generated/graphql';`
export const opportunityProviderLabelsMap: Record<OpportunityProvider, string> = {
  Betterplace: 'Betterplace',
  Catchafire: 'Catchafire',
  GlobalGiving: 'GlobalGiving',
  Goodera: 'Goodera',
  Idealist: 'Idealist',
  PointsOfLight: 'Points of Light',
  VolunteerGov: 'Volunteer.gov',
  VolunteerMatch: 'VolunteerMatch',
};

export const DISCONTINUED_OPPORTUNITY_PROVIDERS = [
  OpportunityProvider.Betterplace,
  OpportunityProvider.Catchafire,
];
